import React, { useContext, useEffect } from "react";
import { Reorder, useDragControls } from "framer-motion";
import { DashMedidasSectionOrderContext } from "../../context/DashMedidasSectionOrderContext";

const LAYOUT_TRANSITION = {
  type: "spring",
  stiffness: 320,
  damping: 32,
  mass: 0.85,
};

const DashMedidasSortableSection = ({
  sectionId,
  className,
  children,
  onDragStart,
  onDragEnd,
}) => {
  const ctx = useContext(DashMedidasSectionOrderContext);
  const controls = useDragControls();

  useEffect(() => {
    if (!ctx) return undefined;
    return ctx.registerDragStart(sectionId, (event) => controls.start(event));
  }, [ctx, sectionId, controls]);

  return (
    <Reorder.Item
      as="div"
      value={sectionId}
      dragListener={false}
      dragControls={controls}
      layout="position"
      transition={LAYOUT_TRANSITION}
      dragTransition={{
        bounceStiffness: 280,
        bounceDamping: 28,
        power: 0.15,
        timeConstant: 200,
      }}
      dragElastic={0.08}
      className={className}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      whileDrag={{
        boxShadow: "0 14px 32px rgba(28, 66, 32, 0.16)",
        zIndex: 20,
        cursor: "grabbing",
      }}
    >
      {children}
    </Reorder.Item>
  );
};

export default DashMedidasSortableSection;
